import { AnyAction } from "redux";
import * as ONBOARDING_AT from "./actionTypes";
import { SubmitState } from "../../../../models/state";
import { fulfilled } from "../../app/utils";

const initialState = (): SubmitState => ({
    success: false,
});

const reducer = (state = initialState(), action: AnyAction): SubmitState => {
    switch (action.type) {
        case fulfilled(ONBOARDING_AT.ONBOARDING_SUBMIT_ORDER):
            return {
                ...state,
                success: action.payload.success,
            };
        default:
            return state;
    }
};

export default reducer;
